import { CustomerGroupModel, FileModel, PackingDayModel, DataProvinceModel } from '.';
import { unescape } from 'html-escaper';
import { translate } from '../helpers/frontend';
import { SYSTEM_LANGUAGES } from '../actions/variables';

/*
  type : Number
    1  = Delivery by LF / Kerry Express
      subtype : Number
        1 = LF
        2 = Kerry Express
    2  = Click & Collect
    3  = Delivery by 3rd Party
      subtype : Number
        1 = Grab
        2 = Kerry Express
    4  = By Appointment
    5  = ??
    6  = Delivery by LF / Nim Express
      subtype : Number
        1 = LF
        2 = Nim Express
    7  = Delivery by LF
    8  = Internal Logistics
    9  = Internal Logistics (Kerry Express)
    10 = Internal Logistics (Nim Express)
    11 = DHL
      subtype : Number
        1 = Pickup from LF
        2 = Pickup from Store
        3 = Internal Warehouse

  shippingRules : Array
    shippingRule : Object
      province : ObjectId
      inService : Number
      forAllZipcodes : Number
      forZipcodes : Array
        
  packingDays : Array
    packingDay : Object
      dayIndex :
        0 = วันอาทิตย์
        1 = วันจันทร์
        2 = วันอังคาร
        3 = วันพุธ
        4 = วันพฤหัสบดี
        5 = วันศุกร์
        6 = วันเสาร์
      startTime
      endTime
      duration : Number
*/

export class PartnerShippingModel {
  constructor(data={}) {
    this._id = data?._id || null;

    this.name = unescape(data.name || '');
    this.displayName = unescape(data.displayName || '');
    this.description = unescape(data.description || '');

    this.minimumOrder = data.minimumOrder || data.minimumOrder===0? Number(data.minimumOrder): null;
    this.maximumOrder = data.maximumOrder || data.maximumOrder===0? Number(data.maximumOrder): null;

    this.icon = new FileModel(data.icon || {});

    this.type = data.type? Number(data.type): null;
    this.subtype = data.subtype? Number(data.subtype): null;
    
    this.lfWeightFactor = Number(data.lfWeightFactor || 0);

    this.kerryMaximumOrder = Number(data.kerryMaximumOrder || 0);
    this.kerryEnableCOD = Number(data.kerryEnableCOD || 0);
    this.kerryMaximumCOD = Number(data.kerryMaximumCOD || 0);

    this.packingDays = (data.packingDays || []).map(d => new PackingDayModel(d));

    this.order = Number(data.order ?? 1);
    this.status = Number(data.status || 0);

    this.shippingRules = (data.shippingRules || []).map(d => ({
      province: new DataProvinceModel(d.province || {}),
      inService: Number(d.inService || 0),
      forAllZipcodes: Number(d.forAllZipcodes || 0),
      forZipcodes: (d.forZipcodes || []).map(d => `${d}`),
    }));

    this.shippingPrices = (data.shippingPrices || []).map(d => ({
      maxWeight: d.maxWeight || d.maxWeight===0? Number(d.maxWeight): null,
      maxDimensionTotal: Number(d.maxDimensionTotal || 0),
      price: Number(d.price || 0),
      forAllProvinces: d.forAllProvinces? 1: 0,
      conditions: (d.conditions || []).map(k => ({
        provinces: (k.provinces || []).map(m => new DataProvinceModel(m)),
        price: Number(k.price || 0),
      })),
    }));

    this.forCustomerGroups = (data.forCustomerGroups || []).map(d => new CustomerGroupModel(d));

    // For External Shop
    this.isFlatRate = Number(data.isFlatRate || 0);
    this.flatRates = (data.flatRates || []).map(d => this.initFlatRate(d));

    // Localization
    this.localization(data);
  }
  localization(data){
    let self = this;
    self.localizedKeys = [ 'displayName', 'description' ];
    SYSTEM_LANGUAGES.forEach(lang => {
      self.localizedKeys.forEach(k => {
        let key = `${k}${lang}`;
        self[key] = data[key]? unescape(data[key]): data[k];
      });
    });
  }

  isValid() { return this._id? true: false; }
  
  initShippingPrice() {
    return {
      maxWeight: null,
      maxDimensionTotal: null,
      price: null,
      forAllProvinces: 1,
      conditions: [],
    };
  }
  initShippingPriceCondition() {
    return {
      provinces: [],
      price: null,
    };
  }
  initFlatRate(d={}) {
    return {
      isDefault: Number(d.isDefault || 0),
      shippingCost: Number(d.shippingCost || 0),
      provinces: (d.provinces || []).map(k => new DataProvinceModel(k)),
    };
  }

  displayStatus(langObj={}) {
    if(!this.isValid()) return (<></>);
    if(this.status === 1) return (<span className="ss-tag bg-success">{translate('Active', langObj)}</span>);
    return (<span className="ss-tag bg-warning">{translate('Inactive', langObj)}</span>);
  }
  displayIsFlatRate(langObj={}) {
    if(!this.isValid()) return (<></>);
    if(this.isFlatRate === 1) return (<span className="ss-tag bg-success">{translate('Yes', langObj)}</span>);
    return (<span className="ss-tag bg-warning">{translate('No', langObj)}</span>);
  }

  existInGroup(groupId) {
    if(groupId && this.forCustomerGroups && this.forCustomerGroups.length) {
      const containGroup = this.forCustomerGroups.find(d => d._id === groupId) !== undefined;
      if(containGroup){
        return true;
      }else return false;
    } else return false;
  }
}